import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  categoryAddAction,
  categoryByIdAction,
  editCategoryAction,
  uploadFileAction,
} from "../actions/category";
import { backendImageUrl, RoutesPaths } from "../Router/constant";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ContentLoader from "react-content-loader";

export default function EditCategory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const CategoryId = location.pathname?.split("/")[3];
  const { categoryListById } = useSelector((state) => state.category);
  /* =======================
     STATES
  ======================= */
  const [formData, setFormData] = useState({
    name: {
      en: "",
      pt: "",
    },
    description: {
      en: "",
      pt: "",
    },
    status: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isimageId, setImageId] = useState();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const isLoadingData =
    !categoryListById?.data || categoryListById?.data?._id !== CategoryId;

  /* =======================
     HANDLERS
  ======================= */

  useEffect(() => {
    dispatch(categoryByIdAction(CategoryId));
  }, [CategoryId]);

  useEffect(() => {
    if (categoryListById?.success && categoryListById?.data) {
      const data = categoryListById.data;
      console.log(data, 'data')
      setFormData({
        name: {
          en: data.name?.en || "",
          pt: data.name?.pt || "",
        },
        description: {
          en: data.description?.en || "",
          pt: data.description?.pt || "",
        },
        status: data?.status || "",
      });

      setImagePreview(
        backendImageUrl + categoryListById.data?.icon?.fileName || null,
      );
      setImageId(categoryListById.data?.icon?._id);
    }
  }, [categoryListById]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [field, lang] = name.split(".");

      setFormData((prev) => {
        const updatedField = {
          ...prev[field],
          [lang]: value,
        };

        const updatedData = {
          ...prev,
          [field]: updatedField,
        };

        // ✅ Remove error ONLY when BOTH filled
        if (field === "name") {
          if (
            updatedField.en.trim() !== "" &&
            updatedField.pt.trim() !== ""
          ) {
            setErrors((prevErr) => ({
              ...prevErr,
              name: "",
            }));
          }
        }

        if (field === "description") {
          if (
            updatedField.en.trim() !== "" &&
            updatedField.pt.trim() !== ""
          ) {
            setErrors((prevErr) => ({
              ...prevErr,
              description: "",
            }));
          }
        }

        return updatedData;
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        icon: "Only PNG, JPG, JPEG files are allowed",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, icon: "" }));
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
    const payload = new FormData();
    payload.append("files", file);
    try {
      const response = await dispatch(uploadFileAction(payload));
      if (response?.data) {
        setImageId(response.data.data._id);
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        icon: "Image upload failed",
      }));
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  /* =======================
     VALIDATION
  ======================= */
  const validate = () => {
    let newErrors = {};


    if (!formData.name.en.trim() || !formData.name.pt.trim()) {
      newErrors.name = "Both English and Portuguese names are required";
    }

    if (!formData.description.en.trim() || !formData.description.pt.trim()) {
      newErrors.description =
        "Both English and Portuguese descriptions are required";
    }

    if (!imagePreview) {
      newErrors.icon = "Category image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* =======================
     SUBMIT
  ======================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const payload = {
        name: formData.name,
        description: formData.description,
        icon: isimageId,
      };
      const resp = await dispatch(editCategoryAction(CategoryId, payload));
      if (resp.data.success) {
        navigate(RoutesPaths.CATEGORIES);
      }
    } catch (error) {
      toast.error("error:", error);
    } finally {
      setLoading(false);
    }
  };

  const canceChanges = () => {
    navigate(RoutesPaths.CATEGORIES);
  };
  /* =======================
     JSX
  ======================= */

  return (
    <>
      {isLoadingData ? (
        <div className="container-fluid contactSkeleton">
          {[...Array(6)].map((_, i) => (
            <ContentLoader key={i} width="100%" height={50}>
              <rect x="0" y="0" rx="5" ry="5" width="100%" height="50" />
            </ContentLoader>
          ))}
        </div>
      ) : (
        <div className="container-fluid mainConatinerSection">
          <form
            className="form d-flex flex-column flex-lg-row"
            onSubmit={handleSubmit}
          >
            {/* LEFT SIDE */}
            <div className="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10">
              {/* IMAGE UPLOAD */}
              <div className="card card-flush py-4">
                <div className="card-header">
                  <div className="card-title">
                    <h2 className="required">Thumbnail</h2>
                  </div>
                </div>

                <div className="card-body text-center pt-0">
                  <div
                    className={`image-input image-input-outline mb-3 ${imagePreview
                      ? ""
                      : "image-input-empty image-input-placeholder"
                      }`}
                  >
                    <div
                      className="image-input-wrapper w-150px h-150px"
                      style={{
                        backgroundImage: imagePreview
                          ? `url(${imagePreview})`
                          : "none",
                      }}
                    ></div>

                    <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow pencilIconSection">
                      <i className="ki-duotone ki-pencil fs-7">
                        <span className="path1 searchPath"></span>
                        <span className="path2 searchPath"></span>
                      </i>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        hidden
                        onChange={handleImageChange}
                      />
                    </label>

                    {imagePreview && (
                      <span
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow closeIconSection"
                        onClick={handleRemoveImage}
                      >
                        <i className="ki-duotone ki-cross fs-2">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                    )}
                  </div>

                  {errors.icon && (
                    <div className="text-danger fs-7">{errors.icon}</div>
                  )}

                  <div className="text-muted fs-7">
                    Only *.png, *.jpg and *.jpeg image files are accepted
                  </div>
                </div>
              </div>

              {/* STATUS */}
              {/* <div className="card card-flush py-4">
                <div className="card-header">
                  <div className="card-title">
                    <h2>Status</h2>
                  </div>
                </div>

                <div className="card-body pt-0">
                  <select
                    className="form-select"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="published">Published</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="unpublished">Unpublished</option>
                  </select>
                </div>
              </div> */}
            </div>

            {/* RIGHT SIDE */}
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
              <div className="card card-flush py-4">
                <div className="card-header">
                  <div className="card-title">
                    <h2>General</h2>
                  </div>
                </div>

                <div className="card-body pt-0">
                  {/* NAME */}
                  <div className="mb-10">
                    <label className="required form-label">Category Name (English)</label>
                    <input
                      type="text"
                      name="name.en"
                      className="form-control mb-2"
                      value={formData.name.en}
                      onChange={handleChange}
                    />

                    <label className="required form-label mt-3">Category Name (Portuguese)</label>
                    <input
                      type="text"
                      name="name.pt"
                      className="form-control"
                      value={formData.name.pt}
                      onChange={handleChange}
                    />

                    {errors.name && <p className="text-danger">{errors.name}</p>}
                  </div>

                  {/* DESCRIPTION */}
                  <div className="mb-10">
                    <label className="form-label">Description (English)</label>
                    <textarea
                      name="description.en"
                      className="form-control mb-2"
                      value={formData.description.en}
                      onChange={handleChange}
                    />

                    <label className="form-label mt-3">Description (Portuguese)</label>
                    <textarea
                      name="description.pt"
                      className="form-control"
                      value={formData.description.pt}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <div className="btn btn-light me-5" onClick={canceChanges}>
                  Cancel
                </div>
                <button
                  disabled={loading}
                  type="submit"
                  className="btn buttonPrimary"
                >
                  {!loading && <>Update Category</>}
                  {loading && (
                    <div className="indicator-label">
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      Please wait...
                    </div>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
